<template>
  <v-app id="app" :class="[$mq]">
    <router-view></router-view>
  </v-app>
</template>

<style lang="scss">
.mobile {
  header {
    height: auto !important;
  }
  .v-toolbar__content {
    height: auto !important;
  }
}

</style>

<script>

export default {
  name: 'TennisApp',
}
</script>
